import { render, staticRenderFns } from "./course-item.vue?vue&type=template&id=0a33f975&scoped=true"
import script from "./course-item.vue?vue&type=script&lang=js"
export * from "./course-item.vue?vue&type=script&lang=js"
import style0 from "./course-item.vue?vue&type=style&index=0&id=0a33f975&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a33f975",
  null
  
)

export default component.exports